import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useUser from '../../hooks/useUser';
import CEOItemReport from './ceo/ItemReport';
import AdminItemReport from './admin/ItemReport';
import ManagerItemReport from './manager/ItemReport';
import { clearErrors } from '../../store/slices/itemReportSlice';

const ItemReports = () => {
    const dispatch = useDispatch();
    const { userRole } = useUser();

    useEffect(() => {
        dispatch(clearErrors());
    }, [dispatch]);

    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';

    if (roleLower === 'ceo') {
        return <CEOItemReport />;
    } else if (roleLower === 'admin') {
        return <AdminItemReport />;
    } else if (roleLower === 'manager') {
        return <ManagerItemReport />;
    } else {
        return <ManagerItemReport />;
    }
};

export default ItemReports;
